var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighPriorityTickets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.75 15.952L25.7 12.477L26.125 7.87695L21.6125 6.85195L19.25 2.87695L15 4.70195L10.75 2.87695L8.3875 6.85195L3.875 7.86445L4.3 12.4645L1.25 15.952L4.3 19.427L3.875 24.0395L8.3875 25.0645L10.75 29.0395L15 27.202L19.25 29.0269L21.6125 25.052L26.125 24.0269L25.7 19.427L28.75 15.952ZM23.1125 18.5895L23.4375 22.077L20.0125 22.852L18.225 25.8645L15 24.4769L11.775 25.8645L9.9875 22.852L6.5625 22.077L6.8875 18.577L4.575 15.952L6.8875 13.302L6.5625 9.82695L9.9875 9.06445L11.775 6.05195L15 7.42695L18.225 6.03945L20.0125 9.05195L23.4375 9.82695L23.1125 13.3145L25.425 15.952L23.1125 18.5895ZM13.75 19.702H16.25V22.202H13.75V19.702ZM13.75 9.70195H16.25V17.202H13.75V9.70195Z",
    fill: "#F59E0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighPriorityTickets);
export default __webpack_public_path__ + "static/media/High Priority Tickets.fca046cae9db354a8716cfafbfee5ddc.svg";
export { ForwardRef as ReactComponent };